<template>
    <div class="add-matrix">
      <div class="file-block">
        <div v-show="!selectedFile" class="set-file-btn">
          <label for="file-input-matrix" class="file-label">Загрузить подпись</label>
          <input id="file-input-matrix" type="file" ref="fileInput" accept=".png, .jpg" class="file-input-matrix" @change="handleFileChange" />
        </div>
      </div>
      
      <div class="upload-block">
        
        <button 
        v-if="selectedFile" 
        @click="submit" 
        class="upload-button">
        <p v-if="loading"><mini-loader></mini-loader></p>
        <p v-else>Отправить</p>
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import ApiConnector from '@/backend/apiModels/CRUDrequest'
  import { createToaster } from "@meforma/vue-toaster";
  import { useErrorHandler } from '@/hooks/errorHandler';
  
  export default {
    name: 'SignatureUpload',
    setup() {
      const loading = ref(false)
      const fileInput = ref(null);
      const selectedFile = ref('');
      const api = new ApiConnector('base')
      const toaster = createToaster()
  
      const handleFileChange = () => {
        const file = fileInput.value.files[0];
        if (file) {
          selectedFile.value = file.name;
        } else {
          selectedFile.value = '';
        }
      };
  
      
      const submit = async () => {
        const file = fileInput.value.files[0];
        if (file && !loading.value) {
          try{
            loading.value = true
            const { response, request } = api.addSignature('users/signature',file);
            await request();
            toaster.success(response.value.msg)  
          }catch(err){
            useErrorHandler(err)
          }
          
        }
        fileInput.value = ''
        selectedFile.value = ''
        loading.value = false
      }
  
      return {
        loading,
        fileInput,
        selectedFile,
        handleFileChange,
        submit,
      };
    },
  };
  </script>
  
  <style scoped>
  .add-matrix {
    display: flex;
    flex-direction: column;
  }
  
  .file-block{
    display: flex;
    align-items: center;
  }
  
  .file-label {
    font-size: 10px;
    padding: 5px;
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .file-label:hover {
    background-color: #0e6572;
  }
  
  .file-label:active {
    background-color: #0e6572;
  }
  
  .file-input-matrix {
    display: none;
  }
  
  .file-name{
    margin-left: 10px;
  }
  
  .upload-button {
    padding: 5px;
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .upload-button:hover {
    background-color: #0e6572;
  }
  
  .upload-button:active {
    background-color: #0e6572;
  }
  
  .upload-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
  }
  
  .loader {
    max-width: 20px;
    max-width: 20px;
  }

  .upload-block{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  </style>
  